import React from 'react';
import dashify from 'dashify';
import styles from './NewAuthorContent.module.scss';
import { formatTwitterLink } from '@benzinga/utils';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { Icon } from '@benzinga/core-ui';
import { authorTwitterHref } from '../utils/authorSocialHref';
import { FollowAuthorButton } from './FollowAuthorButton';

// export interface AuthorContentProps {
//   authorName: string;
//   authorLink?: string;
//   authorType: string;
//   authorUid?: number;
//   className?: string;
//   secondaryByline?: string;
//   twitter?: string | null;
// }

export interface NewAuthorContentProps {
  authorName: string;
  authorLink?: string;
  authorType: string;
  authorUid?: number;
  className?: string;
  created?: string;
  isDraft?: boolean;
  isPartialView?: boolean;
  isTemplate?: boolean;
  readTime?: string;
  secondaryByline?: string;
  twitter?: string | null;
  url?: string;
}

const generateAuthorByLine = (author, authorDetailLink, authorType) => {
  if (author === null) return null;

  let authorName = author || 'Benzinga Staff';

  if (authorDetailLink) {
    authorName =
      authorName !== 'Benzinga Staff' ? (
        <a className="author-name font-semibold" data-action="Clicked Author Link" href={authorDetailLink}>
          {authorName}
        </a>
      ) : (
        'Benzinga Staff'
      );
  }

  let authorByLine = '';
  if (authorType) {
    authorByLine = `${authorType}`;
  }

  return (
    <div>
      <span className="mr-1">by {''}</span>
      <span>
        {authorName} {''}
      </span>
      <span className="ml-1">{authorByLine}</span>
    </div>
  );
};

export const NewAuthorContent: React.FC<NewAuthorContentProps> = React.memo(
  ({ authorLink, authorName, authorType, authorUid, className = '', isTemplate, secondaryByline, twitter }) => {
    const authorDetailLink =
      authorLink || (authorName?.trim() ? `${process.env.BASE_URL}/author/${dashify(authorName.toLowerCase())}` : null);

    return (
      <div className={`${styles.container} article-submitted ${className}`}>
        <div className="article-submitted-content flex-wrap">
          <div className="article-author-wrap flex items-center gap-1 text-gray-300">
            <span className="author">{generateAuthorByLine(authorName, authorDetailLink, authorType)}</span>
            {authorUid && (
              <FollowAuthorButton
                authorName={authorName}
                authorUid={authorUid}
                className="text-blue-500 bg-[#1f334b] hover:bg-[#294360] transition duration-300 py-0.5 px-3 rounded"
                variant="text"
              />
            )}
            {!isTemplate && (
              <a
                aria-label="Find on Twitter"
                className="twitter-link"
                href={authorTwitterHref(twitter) ?? formatTwitterLink('benzinga')}
                rel="noreferrer"
                target="_blank"
              >
                <Icon icon={faXTwitter} />
              </a>
            )}
          </div>
          <div>
            <span className="secondary-byline">{secondaryByline}</span>
          </div>
        </div>
      </div>
    );
  },
);
